import { HttpClient } from '@angular/common/http';
import { ProductionProcessingDto } from 'app/client-core/dtos/productionprocessing.model';
import { SiteMenuModel } from './../dtos/site-menu.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { SiteSetupDto } from '../dtos/site-setup.model';
import { RoleModel } from '../dtos/role.model';
import { ProductionProcessingModel } from '../dtos/production-processing.model';
import { ManufacturerDto } from '../dtos/manufacturer.model';

@Injectable()
export class SiteSetupService {
    public newSiteSetupAdded: Subject<any>;
    public newClientSettingAdded: Subject<any>;
    constructor(
        private apiService: ApiService,
        private router: Router
    ) {
        this.newSiteSetupAdded = new Subject<any>();
        this.newClientSettingAdded = new Subject<any>();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getSiteSetups(params?: any): Observable<ApiResponse<ApiPagedResponse<SiteSetupDto>>> {
        return this.apiService.get<ApiPagedResponse<SiteSetupDto>>('sitesetup', params);
    }

    getSiteSetup(id: number): Observable<ApiResponse<SiteSetupDto>> {
        return this.apiService.get<SiteSetupDto>(`sitesetup/${id}`);
    }

    getSiteMenus(id: number): Promise<Array<SiteMenuModel>> {
        return new Promise<Array<SiteMenuModel>>((resolve, reject) => {
            this.apiService.get<any>(`sitesetup/menus/${id}`).subscribe(response => {
                localStorage.setItem('menu_items', JSON.stringify(response.data));
                resolve(response.data as Array<SiteMenuModel>);
            });
        })
    }

    getSiteMenusToEdit(params?: any): Observable<ApiResponse<ApiPagedResponse<SiteSetupDto>>> {
        return this.apiService.get<ApiPagedResponse<SiteSetupDto>>('sitesetup/menus', params);
    }

    getSiteMenu(id: number): Observable<any> {
        return this.apiService.get<any>(`sitesetup/menutoedit/${id}`);
    }

    _getCachedSiteMenu(): Array<SiteMenuModel> {
        const siteMenu = localStorage.getItem('menu_items');
        return JSON.parse(siteMenu) as Array<SiteMenuModel>;
    }

    saveSiteSetup(params?: SiteSetupDto) {
        return this.apiService.put(`sitesetup`, params);
    }

    saveSiteMenu(params?: SiteMenuModel) {
        return this.apiService.put(`sitesetup/editmenu`, params);
    }

    saveRole(params?: RoleModel) {
        return this.apiService.post(`sitesetup/save-role-claims`, params);
    }

    getLookupMenus(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`sitesetup/lookup/menus`, params);
    }

    getLookupClaims(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`sitesetup/lookup/claims`, params);
    }

    getLookupResources(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`sitesetup/lookup/resources`, params);
    }

    getLookupResourcesWithGroupName(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`sitesetup/lookup/resources-with-groupname`, params);
    }

    getLookupRoles(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`sitesetup/lookup/roles`, params);
    }

    getRole(id: number): Observable<any> {
        return this.apiService.get<any>(`sitesetup/role/${id}`);
    }

    saveProductionProcessing(params?: ProductionProcessingModel) {
        return this.apiService.post(`production/productionprocessing`, params);
    }

    getProductionProcessingList(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`production/productionprocessing`, params);
    }

    saveManufacturer(params?: ManufacturerDto) {
        return this.apiService.post(`production/manufacturer`, params);
    }

    getManufacturers(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`production/manufactures`, params);
    }

    getManufacturer(id: number): Observable<any> {
        return this.apiService.get<any>(`production/manufactures/${id}`);
    }

    getProductionProcessing(id: number): Observable<any> {
        return this.apiService.get<any>(`production/productionprocessing/${id}`);
    }

    getClientSetting(id: number): Observable<any> {
        return this.apiService.get<any>(`customizationrequest/clientsettings/${id}`);
    }

    saveClientSettings(params?: ManufacturerDto) {
        return this.apiService.post(`customizationrequest/clientsettings`, params);
    }

    getClientSettings(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`customizationrequest/clientsettings`, params);
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/site-setup.ts